<template>
     <div class="wrap">
        <div class="wrap_inner">
            <div class="wrap_main">
                <div class='mainlist'>
                    <div style="position:relative;width: 100%;height: 148px;">
                       <!-- <img src="./image/my-banner@2x.png" style="width: 100%;height: 100%"></img>-->
                    </div>
                    <div class="engSty">
                          <img :src="ImgResult" />
                    </div>
                </div>
            </div>
        </div>
     </div>


</template>
<script>
    export default{
        name:"sign",
        components:{},
        data(){
            return {
                ImgResult:''
            }
        },
        create(){
 this.ImgResult=this.$route.query.img

        },
        methods:{

        }
    }
</script>
<style scoped>
     .wrap{
            position: absolute;
            top: 0;
            left:0;
            width:100%;
            height:100%;
            overflow: auto;
            background:#e9eef2;
			overflow-x:hidden;
        }
        .wrap_inner{
             min-height: 100%;
             width:100%;
        }
        .wrap_main{
            padding-bottom: 20px;
        }
    .mainlist{
        width:100%;
        height:340px;
    }
    .engSty{
        position:relative;
        width: 100%;
        height: 274px;
        background: #ffffff;
        font-size:12px;
        margin-top:20px;
        box-shadow: 0px 3px 6px 0px rgba(16,82,139,0.16);
    }
    .dialogs{
        position:absolute;
        top:50%;
        left:50%;
        transform:translate(-50%,-50%);
        width: 285px;
        height: 179px;
        background: #ffffff;
        border-radius: 8px;
        z-index:1000
    }
    .digtxt{
        width: 200px;
        height: 28px;
        margin:34px auto;
        font-size: 20px;
        font-weight: 400;
        text-align: center;
        color: #003cff;
        line-height: 33px;
    }
    .reback{
        flex:0 0 100px;
        height: 45px;
        line-height:45px;
        text-align:center;
        background: #ffffff;
        border: 2px solid #0080ff;
        border-radius: 23px;
        color:#0080ff;
        font-size:18px;
    }
    .submit{
        flex:0 0 100px;
        height: 45px;
        line-height:45px;
        text-align:center;
        background: linear-gradient(140deg,#36b3fe 4%, #0080ff 96%);
        border-radius: 23px;
        color:#fff;
        font-size:18px;
    }
</style>
